import Tabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';

/** Tabs whose labels take the surrounding font size, or MUI's compact default size and width when `compact`. */
export const AdaptiveTabs = styled(Tabs, {
  shouldForwardProp: prop => prop !== 'compact',
})<{ compact?: boolean }>(({ compact }) => ({
  '& .MuiTab-root': {
    fontSize: compact ? '0.875rem' : 'inherit',
    minWidth: compact ? 'auto' : 'inherit',
  },
}));
